<!--suppress VueMissingComponentImportInspection, HtmlUnknownAttribute -->
<template>
  <div class="login-form">
    <h1 class="uk-text-center uk-margin">
      <img class="logo" src="../../common/assets/logo.png" alt="Zion Church">
    </h1>

    <div v-if="error" class="uk-alert-danger" uk-alert>
      {{ error }}
    </div>

    <ui-form ref="form" class="login-box" :model="model">
      <ui-form-item label="Email" prop="email" required email>
        <ui-form-input
          v-model="model.email"
          name="email"
          id="login-email"
          type="email"
          class="email-field"
          autofocus />
      </ui-form-item>

      <ui-form-item label="Password" prop="password" required>
        <ui-form-input
          v-model="model.password"
          name="password"
          id="login-password"
          :type="showPassword ? 'text' : 'password'"
          class="password-field">
          <span slot="append" @click="showPassword = !showPassword">
            <span v-if="showPassword" uk-icon="eye-slash"></span>
            <span v-else uk-icon="eye"></span>
          </span>
        </ui-form-input>
      </ui-form-item>

      <div class="uk-text-center">
        <button
          type="submit"
          class="uk-button uk-button-primary"
          @click.prevent="submit"
          :disabled="submitting"
        >
          <span v-if="submitting" uk-spinner></span>
          <span v-else>Login</span>
        </button>
      </div>
    </ui-form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import api from '../api'

export default {
  data: () => ({
    error: null,
    showPassword: false,

    model: {
      email: '',
      password: '',
    },
    submitting: false,
  }),

  methods: {
    ...mapActions(['login']),

    async submit() {
      this.$refs.form.validate()
        .then(() => {
          this.submitting = true
          this.error = null

          const { email, password } = this.model

          // eslint-disable-next-line
          grecaptcha.execute(window.__globals.recaptchaSiteKey, { action: 'login' }).then((token) => {
            api.endpoints.auth
              .login(
                {
                  email,
                  password,
                  _remember_me: true,
                  recaptcha: token,
                },
                { handleErrors: false }
              )
              .then((response) => {
                this.login({ user: response.data.user })
                this.$emit('login')
              })
              .catch((error) => {
                this.error = 'Error. Please try again.'

                if (error.response && error.response.data && error.response.data.detail) {
                  this.error = error.response.data.detail
                }
              })
              .then(() => {
                this.submitting = false
              })
          })
        })
        .catch(() => {
        })
    },

    reset() {
      this.email = ''
      this.password = ''
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$refs.email) {
        this.$refs.email.focus()
      }
    })
  },
}
</script>

<style lang="scss" scoped>
img {
  max-width: 100%;
}

.logo {
  width: 200px;
}

.heading {
  color: #505050;
  font-size: 1.4rem;
  text-align: center;
  text-transform: uppercase;
}

.forgot {
  color: inherit;
  font-weight: 600;
  margin-left: auto;
  text-decoration: none;
}

.forgot:hover {
  text-decoration: underline;
}

.email-field,
.password-field {
  background: #fff;
}
</style>
